import React from "react";
import { Link } from "react-router-dom";

function Gallery() {
  const data = [
    {
      id: 1,
      img: "assets/images/portfolio/portfolio-3-1.jpg",
      name: "Health Insurance",
    },
    {
      id: 2,
      img: "assets/images/portfolio/portfolio-3-2.jpg",
      name: "Life Insurance",
    },
    {
      id: 3,
      img: "assets/images/portfolio/portfolio-3-3.jpg",
      name: "Car Insurance",
    },
  ];
  const data2 = [
    {
      id: 1,
      name: "Trusted Partners",
      img: "flaticon-trust",
    },
    {
      id: 2,
      name: "Protective Insurance",
      img: "flaticon-medical-insurance",
    },
    {
      id: 3,
      name: "Commercial Insurance",
      img: "flaticon-commercial",
    },
    {
      id: 4,
      name: "Easy Process Systems",
      img: "flaticon-agile",
    },
  ];
  return (
    <>
      <section className="portfolio-one">
        <div className="container">
          <div className="portfolio-one__top">
            <div className="sec-title text-start">
              <p className="sec-title__tagline">Photo Gallery</p>

              <h3 className="sec-title__title">Take a look about our inside</h3>
            </div>

            <div className="portfolio-one__btns">
              <Link
                to="/portfoliogrid"
                className="thm-btn thm-btn--three portfolio-one__btn"
              >
                <span>
                  View More
                  <i className="far fa-arrow-right" />
                </span>
              </Link>
            </div>
          </div>

          <div className="row gutter-y-30">
            {data.map((item) => (
              <div className="col-md-6 col-lg-4" key={item.id}>
                <div className="portfolio-card portfolio-card--two portfolio-card--three">
                  <div className="portfolio-card__image">
                    <img src={item.img} />
                    <div className="portfolio-card__content">
                      <h3 className="portfolio-card__title">
                        <Link to="/portfoliodetails">{item.name}</Link>
                      </h3>
                      <span className="portfolio-card__tagline">Insurance</span>

                      <Link
                        to="/portfoliodetails"
                        className="portfolio-card__link"
                      >
                        <i className="far fa-arrow-right" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="cta-three">
        <div className="container">
          <div
            className="cta-three__inner"
            style={{
              backgroundImage:
                "url(assets/images/background/cta-three-bg-1-1.jpg)",
            }}
          >
            <div className="sec-title text-start">
              <p className="sec-title__tagline">Get free estimate</p>

              <h3 className="sec-title__title">
                Get an insurance agenct! started with us
              </h3>
            </div>

            <div className="cta-one__content">
              <Link to="/pricing" className="thm-btn thm-btn--two cta-one__btn">
                <span>
                  Get a Quote
                  <i className="far fa-arrow-right" />
                </span>
              </Link>

              <div className="cta-one__info">
                <div className="cta-one__info__icon">
                  <i className="far fa-phone-plus" />
                </div>

                <div className="cta-one__info__content">
                  <span className="cta-one__info__name">Phone No</span>
                  <Link to="tel:+000(123)45688">+000 (123) 456 88</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="faq-three faq-three--home-3 faq-three--home-2"
        style={{
          backgroundImage: "url(assets/images/shapes/faq-3-home-2-bg.png)",
        }}
      >
        <div className="container">
          <div className="row gutter-y-60">
            <div className="col-md-12 col-lg-6">
              <div className="faq-three--home-2__images">
                <img src="assets/images/resources/faq-3-home-2-1.jpg" />
                <img src="assets/images/resources/faq-3-home-2-2.jpg" />
                <div className="about-five__image__caption">
                  <h3 className="about-five__image__caption__title">
                    2 Years Of Experience in Insurance Services
                  </h3>

                  <p className="about-five__image__caption__text">
                    CEO &amp; Founder
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-12 col-lg-6">
              <div className="sec-title text-start">
                <p className="sec-title__tagline">get consultations</p>

                <h3 className="sec-title__title">
                  Find Best Insurance Agent or Need Consultations?
                </h3>
              </div>

              <div className="faq-three__right">
                {data2.map((item) => (
                  <div className="faq-three__box" key={item.id}>
                    <div className="faq-three__box__icon">
                      <i className={item.img} />
                    </div>

                    <h3 className="faq-three__box__title">
                      <Link to="/insurancesdetails">{item.name}</Link>
                    </h3>

                    <Link
                      to="/insurancesdetails"
                      className="faq-three__box__link"
                    >
                      <i className="far fa-long-arrow-right" />
                    </Link>

                    <div className="faq-three__box__hover">
                      <div className="faq-three__box__hover__icon">
                        <i className={item.img} />
                      </div>

                      <h3 className="faq-three__box__hover__title">
                        <Link to="/insurancesdetails">{item.name}</Link>
                      </h3>

                      <div className="faq-three__box__hover__text">
                        Take a trivial example which of ever undertakes
                      </div>
                    </div>
                  </div>
                ))}

              
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Gallery;
